module.exports = __webpack_public_path__ + "static/img/10.46e01c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/10.png
// module id = s9If
// module chunks = 0